import {
  NgModule,
  isDevMode,
  CUSTOM_ELEMENTS_SCHEMA,
  ErrorHandler,
  APP_INITIALIZER,
} from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from 'src/environments/environment';
import {
  HttpClientModule,
  HTTP_INTERCEPTORS,
  HttpClient,
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtInterceptor } from './core/_interceptors/jwt.interceptors';
import { ErrorInterceptor } from './core/_interceptors/error.interceptors';
import { ResponseInterceptor } from './core/_interceptors/response.interceptors';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { CommonModule } from '@angular/common';
import * as Sentry from '@sentry/angular-ivy';

import { metaReducers, reducers } from './core/_reducers';
import { LottieModule } from 'ngx-lottie';
// import { LottiePlayer } from "@lottiefiles/lottie-player";
import player from 'lottie-web';
import { Router } from '@angular/router';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import * as SentryAngular from '@sentry/angular-ivy';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideDatabase, getDatabase } from '@angular/fire/database';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ErrorHandlingService } from './core/_services/error-handling.service';

export function playerFactory() {
  return player;
}

// Registra los datos de localización para español
registerLocaleData(localeEs);

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    CommonModule,
    MatSnackBarModule,
    MatDialogModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    StoreModule.forRoot(reducers, { metaReducers }),
    EffectsModule.forRoot([]),
    StoreRouterConnectingModule.forRoot(),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Número máximo de acciones en el historial
      logOnly: environment.production, // Restringir las herramientas solo a entornos de producción
    }),
    HttpClientModule,
    BrowserAnimationsModule,
    AngularSvgIconModule.forRoot(),
    LottieModule.forRoot({ player: playerFactory }),
    NgOptimizedImage,
    provideFirebaseApp(() => initializeApp({ ...environment.firebase })),
    provideDatabase(() => getDatabase()),
    TranslateModule.forRoot({
      defaultLanguage: 'es',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'es' },
    ErrorHandlingService,
    ...(environment.type === 'production'
      ? [
          {
            provide: ErrorHandler,
            useClass: class extends ErrorHandler {
              constructor(private errorHandlingService: ErrorHandlingService) {
                super();
              }

              override handleError(error: any) {
                this.errorHandlingService.logError(error);
              }
            },
            deps: [ErrorHandlingService],
          },
          {
            provide: SentryAngular.TraceService,
            deps: [Router],
          },
          {
            provide: APP_INITIALIZER,
            useFactory: () => () => {},
            deps: [SentryAngular.TraceService],
            multi: true,
          },
        ]
      : [
          // Error handler básico para desarrollo
          {
            provide: ErrorHandler,
            useClass: class extends ErrorHandler {
              override handleError(error: any) {
                console.error('Development Error Handler:', error);
              }
            },
          },
        ]),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
